module.exports = {
    /**
     * Loader promise
     *
     * @type  {Promise}
     * @private
     */
    promise: null,

    /**
     * Loads the YouTube Player API.
     *
     * @return  {Promise}  Resolves when API is loaded
     * @public
     */
    load: function() {
        var resolver,
            rejector,
            script;

        // Already loading or loaded
        if (this.promise) {
            return this.promise;
        }

        // New loading promise
        this.promise = new Promise(function(resolve, reject) {
            resolver = resolve;
            rejector = reject;
        });

        script         = document.createElement("script");
        script.src     = "https://www.youtube.com/iframe_api";
        script.onerror = rejector;

        window.onYouTubeIframeAPIReady = function() {
            resolver();
        };

        document.head.appendChild(script);

        return this.promise;
    }

};
